import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryBillingColumns } from '../constants/dictionary-billing-columns.constant';

export const generateBillingThirdColumn = () => {
	return [
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].colony,
			dataIndex: 'colony',
      key: 'colony',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].province,
			dataIndex: 'province',
      key: 'province',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].commune,
			dataIndex: 'commune',
      key: 'commune',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].city,
			dataIndex: 'city',
      key: 'city',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].zip_code,
			dataIndex: 'zip_code',
      key: 'zip_code',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].country,
			dataIndex: 'country',
      key: 'country',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].reference,
			dataIndex: 'reference',
      key: 'reference',
      align:'center'

		},
		{
			title: dictionaryBillingColumns[Enviroment.LANGUAGE].cfdi,
			dataIndex: 'cfdi',
      key: 'cfdi',
      align:'center'

		},
	];
};
